var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "event-modal faq-modal",
      attrs: {
        name: "faqModal",
        width: "90%",
        height: "auto",
        scrollable: true
      }
    },
    [
      _c("div", { staticClass: "modal-header" }, [
        _c("div", { staticClass: "modal-header-text" }, [
          _c("span", [_vm._v("BIOMETRIC EVENT INFORMATION AND POLICIES")])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "modal-close-img",
            on: {
              click: function($event) {
                _vm.hideModal()
              },
              mouseover: function($event) {
                _vm.isHoverClose = true
              },
              mouseleave: function($event) {
                _vm.isHoverClose = false
              }
            }
          },
          [
            !_vm.isHoverClose
              ? _c("img", {
                  attrs: {
                    src: require("../../../static/img/info-modal-close.svg"),
                    alt: "close"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isHoverClose
              ? _c("img", {
                  attrs: {
                    src: require("../../../static/img/info-modal-close-hover.svg"),
                    alt: "close"
                  }
                })
              : _vm._e()
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-body" }, [
        _c("div", { staticClass: "faq-section" }, [
          _c("span", { staticClass: "modal-body-title" }, [
            _vm._v("Standard Biometric Event")
          ]),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-text" }, [
            _vm._v(
              "A standard biometric event includes: Finger Stick Blood Draw testing for Total Cholesterol, LDL, HDL, Trig and Blood Glucose. Wellmetrics testing for Blood Pressure, Heart Rate, Body Mass Index (BMI), Waist to Height Ratio (WtHR). If you require services outside of these standard options, please indicate in the custom event notes. "
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "faq-section" }, [
          _c("span", { staticClass: "modal-body-title" }, [
            _vm._v('Definition of an "Event":')
          ]),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-text" }, [
            _vm._v("• Each event subject to Event minimum billing stipulations")
          ]),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-text" }, [
            _vm._v(
              "• Multiple shifts at one location on any single day that are separated by 2 or more hours are considered separate Events"
            )
          ]),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-text" }, [
            _vm._v(
              "• Events on multiple days in one location are considered a separate Event"
            )
          ]),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-text" }, [
            _vm._v(
              "• Each location at same day events is considered a separate Event"
            )
          ]),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-text" }, [
            _vm._v(
              "• Events are a minimum of 4 hours in one day.  Additional fees may be incurred if events are less than 4 hours in duration, or greater then 8 hours."
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "faq-section" }, [
          _c("span", { staticClass: "modal-body-title" }, [
            _vm._v("Policy Information")
          ]),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-sub-title" }, [
            _vm._v("Cancelling or Rescheduling an Event")
          ]),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-text" }, [
            _vm._v(
              "Events cancelled or rescheduled 31 days or more prior to an event will not incur any administrative fees."
            )
          ]),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-text" }, [
            _vm._v(
              "Events cancelled or rescheduled 14 to 30 days prior to an event will be charged and billed for 50% the rate of the event, as well as any direct, non-refundable travel expenses already purchased.  Events cancelled less than 14 days prior to event date will be charged and billed for 100% the rate of the event, as well as any direct, non-refundable travel expenses already purchased."
            )
          ]),
          _c("br"),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-sub-title" }, [
            _vm._v("ADURO Event Weather Policy")
          ]),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-text" }, [
            _vm._v(
              "In the case of inclement weather, it is the responsibility of the client to cancel the event. ADURO will make every reasonable effort to continue on with an event until notified by the client. If an Event is cancelled by the client due to inclement weather, the client is responsible for all non-refundable costs (such as Lead travel). ADURO reserves the right to cancel an event due to safety concerns related to the weather at any time. ADURO will make every reasonable effort to rescheduled a cancelled event within 30 days of original date.  The Client will not incur any cancellation or rescheduling fees due to weather."
            )
          ]),
          _c("br"),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-sub-title" }, [
            _vm._v("Service Changes to an Event")
          ]),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-text" }, [
            _vm._v(
              "Allowable service changes made within 30 days of the scheduled event are not guaranteed and will incur a $250 service fee per change if accepted.  Allowable service changes include a change in the times of the event, an increase in the number of projected participation, or a change of location within the same metro area.  Changes made outside of 30 days do not incur a fee.  Changes will not be accepted within 15 days of the event. To request service changes to an event, please complete the Change Order Form and submit it to the Event Manager."
            )
          ]),
          _c("br"),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-sub-title" }, [
            _vm._v("Events in Remote Locations")
          ]),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-text" }, [
            _vm._v(
              "Locations more than 60 miles from an international airport will incur additional fees including travel expenses for all staff members (rental car, hotel and per diem).  An ADURO Event Manager will notify client if and when additional expenses will be charged when draft of SOF is received."
            )
          ]),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-text" }, [
            _vm._v(
              "Events requiring more than 7 screening stations: Any event that requires more than 7 screening stations will require 2 Event Leads. Screening stations are determined based on event duration and projected participation."
            )
          ]),
          _c("br"),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-sub-title" }, [
            _vm._v("Deposit and Final Billing")
          ]),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "modal-body-text" }, [
            _vm._v(
              "A deposit will be billed out at 50% of the projected participation to confirm each Event.  Deposit payment due upon receipt of deposit invoice. Final billing per event will be whichever is the greater:  1) Actual participation  OR  2) $2,500 site minimum  OR  3) 80% of the expected participation (may not apply to all, see contract for specific details). Biometrics final invoices will include actual travel expenses for the Event Lead(s) (air fare, hotel, auto, per diem)."
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0496e3c3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0496e3c3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/FaqModal.vue
// module id = 1439
// module chunks = 1